export const VIVALDI_THUMBNAIL_RATIO = 50 / 61
export const EMAIL_ADDRESS = "hadrys.mateusz86@gmail.com"
export const LINK_TWITTER = "https://twitter.com/HadrysMateusz"
export const LINK_PORTFOLIO = "https://hadrysmateusz.com/"
